export enum ApproverType {
  Individual = 0,
  Role = 1,
  AutoApproval = 2,
}
